// Date entry as three lists — Month / Day / Year — because the phone's own date
// and time boxes didn't always open a picker or keyboard. Value in and out is
// "YYYY-MM-DD" (or "" when blank), exactly like <input type="date">.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function DatePick({ value, onChange, testid, title }) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));
  const now = new Date();
  const y = m ? Number(m[1]) : null, mo = m ? Number(m[2]) : null, d = m ? Number(m[3]) : null;
  const years = [];
  for (let k = now.getFullYear() - 2; k <= now.getFullYear() + 2; k += 1) years.push(k);
  if (y && !years.includes(y)) years.push(y);
  const daysIn = (yy, mm) => new Date(yy || now.getFullYear(), mm || 1, 0).getDate();
  const put = (yy, mm, dd) => {
    if (!yy || !mm || !dd) { onChange(""); return; }
    const day = Math.min(dd, daysIn(yy, mm));
    onChange(`${yy}-${String(mm).padStart(2, "0")}-${String(day).padStart(2, "0")}`);
  };
  // Picking any one part fills the others from today, so one tap gives a date.
  const pick = (part, v) => {
    const n = Number(v) || null;
    const yy = part === "y" ? n : (y || now.getFullYear());
    const mm = part === "m" ? n : (mo || now.getMonth() + 1);
    const dd = part === "d" ? n : (d || now.getDate());
    if (!n) { onChange(""); return; }
    put(yy, mm, dd);
  };
  const sel = { flex: 1, minWidth: 0, fontSize: "1.05rem", padding: "0.5rem", minHeight: 48 };
  return (
    <div style={{ display: "flex", gap: "0.4rem" }} data-testid={testid || "date-pick"} title={title}>
      <select aria-label="Month" value={mo || ""} onChange={e => pick("m", e.target.value)} style={sel}>
        <option value="">Month</option>
        {MONTHS.map((n, i) => <option key={n} value={i + 1}>{n}</option>)}
      </select>
      <select aria-label="Day" value={d || ""} onChange={e => pick("d", e.target.value)} style={sel}>
        <option value="">Day</option>
        {Array.from({ length: daysIn(y, mo) }, (_, i) => i + 1).map(n => <option key={n} value={n}>{n}</option>)}
      </select>
      <select aria-label="Year" value={y || ""} onChange={e => pick("y", e.target.value)} style={sel}>
        <option value="">Year</option>
        {years.sort((a, b) => a - b).map(n => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
  );
}
